import { useState } from "react";
import { Spin, Flex, Button, Progress } from "antd";

import PlusIcon from "@/icons/PlusIcon";
import TrashIcon from "@/icons/TrashIcon";

import ChecklistItem from "./ChecklistItem";
import Checklist from "./Checklist";

const ChecklistTab = ({
  data,
  pending,
  readOnly,
  canToggle,
  handleEditItem,
  handleDeleteItem,
  handleCheckItem,
  handleDeleteList,
}) => {
  const [showNewItem, setShowNewItem] = useState(false);

  const countChecked = data?.filter((item) => item.is_completed).length || 0;

  const handleSaveNew = (item) => {
    handleEditItem(item);
    setShowNewItem(false);
  };

  const isEmpty = !data?.length && !showNewItem;
  const hasItems = !!data?.length;

  return (
    <Spin spinning={pending}>
      {isEmpty && (
        <Flex vertical gap={15} align="flex-start">
          <div>
            Чек-лист пуст&nbsp;&mdash; критерии успешного выполнения задач
            не&nbsp;добавлены.
          </div>

          {!readOnly && (
            <Button type="primary" onClick={() => setShowNewItem(true)}>
              Добавить критерий
            </Button>
          )}
        </Flex>
      )}

      <Flex vertical gap={15}>
        {hasItems && (
          <>
            <div>
              <div>
                {countChecked}/{data.length}
              </div>
              <Progress
                percent={(countChecked / data.length) * 100}
                showInfo={false}
                strokeColor="#0066A6"
              />
            </div>
            <Checklist
              data={data}
              readOnly={readOnly}
              canToggle={canToggle}
              handleEditItem={handleEditItem}
              handleCheckItem={handleCheckItem}
              handleDeleteItem={handleDeleteItem}
            />
          </>
        )}
        {showNewItem ? (
          <>
            <ChecklistItem
              item={{ title: "" }}
              isEditing
              onSave={handleSaveNew}
              onCheck={() => {}}
              onCancel={() => setShowNewItem(false)}
            />
            {hasItems && (
              <Button
                icon={<TrashIcon />}
                style={{ alignSelf: "flex-end" }}
                onClick={handleDeleteList}
              >
                Удалить все критерии
              </Button>
            )}
          </>
        ) : (
          hasItems &&
          !readOnly && (
            <Flex align="center" justify="space-between">
              <Button
                icon={<PlusIcon />}
                style={{ alignSelf: "flex-start" }}
                onClick={() => setShowNewItem(true)}
              >
                Добавить пункт
              </Button>
              <Button
                icon={<TrashIcon />}
                style={{ alignSelf: "flex-end" }}
                onClick={handleDeleteList}
              >
                Удалить все критерии
              </Button>
            </Flex>
          )
        )}
      </Flex>
    </Spin>
  );
};

export default ChecklistTab;
